import { useQuery } from "@tanstack/vue-query";
import { getAccountingLead, type AccountingLead } from "../services/user";

export function useAccountingLead() {
    const {
        data: accountingLead,
        isLoading: loadingAccountingLead,
    } = useQuery<AccountingLead>({
        queryKey: ["user", "accounting-lead"],
        queryFn: getAccountingLead,
    });

    return {
        accountingLead,
        loadingAccountingLead,
    };
}
